import { Injectable } from "@angular/core";

declare var $: any;
@Injectable()
export class ContinuityOfferService {
    public windowObj: any = window;
    public enableBonusPathV2Flag: boolean = true;
    public continuityOfferType: string = "continuity";
    public freshPassContinuityOffer: string = "IA FRESHPASS";
    public behavioralOfferAttrs = {
        startChallengeButtonName: "Activate",
        challengeCompletedStatusText: "Bonus Path Completed",
        inProgressStatusText: "In Progress",
        grClipTextOMS: "GR Clip",
        ucaEmailOptInTextOMS: "UCA Email Opt In",
        ecomFulfillmentTextOMS: "ECOM Fulfillment",
        grClipButtonText: "Go to Grocery Rewards",
        ucaEmailOptInButtonText: "Go to Account Settings",
        ecomFulfillmentButtonText: "Go to My Cart",
        ucaEmailOptInLink: "/customer-account/communication-preference.html",
        ecomFulfillmentLink: "/",
        grClipLink: "/foru/rewards.html",
        addToMyListBtnText: "Add to My List",
        viewInMyListText: "View in My List",
        myListLink: "/mylist.html",
        startShoppingText: "Start Shopping",
        startShoppingLink: "/",
        freshPassOfferText: "Redeem FreshPass offer",
        freshPassOfferLink: "/freshpass/manage/subscribe"
    };

    public constructor() {
        this.enableBonusPathV2Flag =
            this.windowObj && this.windowObj["SWY"] &&
            this.windowObj["SWY"]["CONFIGSERVICE"] &&
            this.windowObj["SWY"]["CONFIGSERVICE"]["featureToggleConfig"] &&
            this.windowObj["SWY"]["CONFIGSERVICE"]["featureToggleConfig"][
                "disableContinuityOfferV2Flag"
            ]
                ? false
                : true;

        const enableB4UPlusLaunch =
            this.windowObj?.["SWY"]?.CONFIGSERVICE?.featureToggleConfig?.enableB4UPlusLaunch === true;
        if (enableB4UPlusLaunch) {
            this.behavioralOfferAttrs.freshPassOfferText = "Claim forU+ plan";
            this.behavioralOfferAttrs.freshPassOfferLink = "/foruplus";
        }
    }

    public isContinuity(coupon: any): boolean {
        return (
            ((coupon["offerProgramType"] &&
                coupon["offerProgramType"].toLowerCase() ===
                    this.continuityOfferType.toLowerCase()) ||
                (coupon["offerProtoType"] &&
                    coupon["offerProtoType"].toLowerCase() ===
                        this.continuityOfferType.toLowerCase())) &&
            coupon.continuity
        );
    }

    public isClippedStatus(coupon: any): boolean {
        let isClipped: boolean = false;
        if (this.isContinuity(coupon)) {
            if (
                (coupon.status === "U" && coupon.deleted) ||
                coupon.status === "C"
            ) {
                isClipped = true;
            } else if (coupon.status === "U" && !coupon.deleted) {
                isClipped = false;
            }
        }
        return isClipped;
    }

    public isBehaviourOrContinuityCoupon(coupon: any): boolean {
        let flag = false;
        if (coupon?.continuity || (coupon?.qualificationBehavior && coupon?.qualificationBehavior !== "")) flag = true; 
        return flag;
    }
    public isFreshpassContinuityCoupon(coupon: any): boolean {
        let flag = false;
        if (
            coupon.offerProtoType &&
            coupon.offerProtoType.toLowerCase() ===
                this.continuityOfferType.toLowerCase() && coupon.programSubType && coupon.programSubType.trim().toLowerCase() === this.freshPassContinuityOffer.trim().toLocaleLowerCase()
        ) {
            flag = true;
        }
        return flag;
    }
}
